var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useOktaAuth } from '@okta/okta-react';
export var AuthContext = React.createContext({
    sessionExpired: false,
    authenticated: undefined
});
export var WAKE_CHECK_THROTTLE_MS = 1500;
export function AuthProvider(_a) {
    var _this = this;
    var children = _a.children;
    var _b = useOktaAuth(), oktaAuth = _b.oktaAuth, authState = _b.authState;
    var _c = React.useState(false), sessionExpired = _c[0], setSessionExpired = _c[1];
    var _d = React.useState(undefined), authenticated = _d[0], setAuthenticated = _d[1];
    React.useEffect(function () {
        var onExpired = function (key) {
            window.sessionStorage.setItem("TriggerLogout", "false");
            setSessionExpired(true);
        };
        var onRenewed = function (key) {
            setSessionExpired(false);
        };
        oktaAuth.tokenManager.on("expired", onExpired);
        oktaAuth.tokenManager.on("renewed", onRenewed);
        return function () {
            oktaAuth.tokenManager.off("expired", onExpired);
            oktaAuth.tokenManager.off("renewed", onRenewed);
        };
    }, [oktaAuth]);
    React.useEffect(function () {
        var lastWakeCheckAt = 0;
        var checkSessionAfterWake = function () { return __awaiter(_this, void 0, void 0, function () {
            var now, isAuthenticated;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        now = Date.now();
                        if (now - lastWakeCheckAt < WAKE_CHECK_THROTTLE_MS) {
                            return [2 /*return*/];
                        }
                        lastWakeCheckAt = now;
                        if ((authState === null || authState === void 0 ? void 0 : authState.isAuthenticated) !== true) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, oktaAuth.isAuthenticated()];
                    case 1:
                        isAuthenticated = _a.sent();
                        if (!isAuthenticated) {
                            window.sessionStorage.setItem("TriggerLogout", "false");
                            setSessionExpired(true);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var onVisibilityChange = function () {
            if (document.visibilityState === "visible") {
                void checkSessionAfterWake();
            }
        };
        var onWindowFocus = function () {
            void checkSessionAfterWake();
        };
        var onPageShow = function () {
            void checkSessionAfterWake();
        };
        document.addEventListener("visibilitychange", onVisibilityChange);
        window.addEventListener("focus", onWindowFocus);
        window.addEventListener("pageshow", onPageShow);
        return function () {
            document.removeEventListener("visibilitychange", onVisibilityChange);
            window.removeEventListener("focus", onWindowFocus);
            window.removeEventListener("pageshow", onPageShow);
        };
    }, [oktaAuth, authState === null || authState === void 0 ? void 0 : authState.isAuthenticated]);
    React.useEffect(function () {
        setAuthenticated(authState === null || authState === void 0 ? void 0 : authState.isAuthenticated);
    }, [authState === null || authState === void 0 ? void 0 : authState.isAuthenticated]);
    return (_jsx(AuthContext.Provider, { value: { sessionExpired: sessionExpired, authenticated: authenticated }, children: children }));
}
